import { apiRequest } from '../../../shared/services/apiClient';
import {
  PreviewAutomationConditionMatchRequest,
  PreviewAutomationConditionMatchResponse,
  normalizePreviewResult,
} from '../types/AutomationCondition';

export const previewAutomationConditionMatch = async (
  request: PreviewAutomationConditionMatchRequest,
): Promise<PreviewAutomationConditionMatchResponse> => {
  const payload = await apiRequest<any>('/api/v1/automations/preview-match', {
    method: 'POST',
    body: JSON.stringify(request),
  });
  return normalizePreviewResult(payload);
};
